import { render, staticRenderFns } from "./clientsView.vue?vue&type=template&id=40d65562&scoped=true"
import script from "./clientsView.vue?vue&type=script&lang=js"
export * from "./clientsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d65562",
  null
  
)

export default component.exports